"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconTruckTractor = function SvgIconTruckTractor(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "truck tractor icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Truck Tractor Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M38.674 7.492h-12.21v18.824H4v7.176c0 3.87 3.125 7.016 6.987 7.016 3.856 0 6.986-3.146 6.986-7.016h8.491c0 3.87 3.127 7.016 6.987 7.016 3.858 0 6.987-3.146 6.987-7.016H44V21.798L40.712 9.075a2.107 2.107 0 00-2.038-1.583zm-31.182 26a3.5 3.5 0 013.495-3.508 3.502 3.502 0 013.494 3.508c0 1.932-1.568 3.509-3.494 3.509a3.505 3.505 0 01-3.495-3.51zm30.94-21.657l1.697 7.887h-10.1v-8.72h7.375c.495 0 .924.347 1.029.833zm-8.474 21.657a3.499 3.499 0 013.493-3.508 3.501 3.501 0 013.494 3.508c0 1.932-1.566 3.509-3.494 3.509-1.93 0-3.493-1.577-3.493-3.51z"
  }));
};

var _default = SvgIconTruckTractor;
exports.default = _default;